// extracted by mini-css-extract-plugin
export default {"control":"Control_control__oi6Nn","button":"Control_button__AJAQu"};